(function () {
    'use strict';

    angular.module('swif.interventions')

        .service('interventionService', interventionService);

    function interventionService($q, $uibModal, swif, taskService, swifInterventionsConstant, swifOpenbaseCompanyService, AchatsService, AttachmentService) {
        'ngInject';

        var service = {};

        service.currentCollection = {};

        service = swifInterventionsConstant.intervention;
        service.COLLECTION_FIELDS = [
            'actions',
            'ask_id',
            'category_id',
            'contract_id',
            'cost',
            'date_deadline',
            'description',
            'effective_hours',
            'equipment_id',
            'id',
            'swif_id',
            'intervention_assignement_id',
            'is_long_term',
            'sync_state_from_tasks',
            'name',
            'overPourcent',
            'planned_hours',
            'project_type',
            'service_id',
            'state',
            'site1',
            'site_category',
            'site_details',
            'tasks',
            'attachment_count',
            'mail_message_count',
            'sms_message_count',
            'external',
            'geo_point'
        ];

        service.resolveData = function (options) {
            return swif.route.check(options).then(function () {
                var deferred = $q.defer();
                var data = {};
                data.debug = swif.route.debug;
                data.title = 'Interventions';
                data.actionViewsCategory = 'views';
                service.createCollection().then(function (collection) {
                    data.interventions = collection;
                    service.currentCollection = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };

        service.getProjectType = function (project) {
            var projectType = {
                contentType: 'intervention',
                name: 'Intervention'
            };
            if (project) {
                if (project.project_type === 'contract' || project === 'patrimoine_contract') {
                    projectType.contentType = 'patrimoine_contract';
                    projectType.name = 'Control / Contract';
                }
            }
            return projectType;
        };

        service.getFilter = function () {
            var filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['open', 'scheduled', 'pending']);
            swif.data.sortOn(filter, 'id', 'DESC');
            filter.fields = service.COLLECTION_FIELDS;
            return filter;
        };

        service.createCollection = function () {
            var filter = service.getFilter();
            return swif.collections.createOrUpdate(
                'interventions',
                'intervention',
                filter,
                {location: true}
            );
        };

        service.createCollectionTasks = function (intervention, tasksLimit) {
            var filter = {};
            if (typeof tasksLimit != 'undefined') {
                swif.data.setLimit(filter, tasksLimit);
            }
            swif.data.addExtraFilter(filter, 'inInter', 'project_id', '=', intervention.id);
            swif.data.sortOn(filter, 'id', 'ASC');
            filter.fields = taskService.COLLECTION_FIELDS;
            return swif.collections.createOrUpdate(
                'interventions-tasks',
                'task',
                filter
            );
        };

        service.getTooltip = function () {
            /**TODO: refactor this to provide information
             """
             build tooltip information
             """
             def _tooltip(self, cr, uid, ids, myFields, arg, context):
             res = {}
             user_obj = self.pool.get('res.users')

             loc = locale.getlocale()
             ucontext = user_obj.context_get(cr, uid)
             if ucontext and ucontext['lang']:
             locale.setlocale(locale.LC_ALL, (ucontext['lang'], 'UTF-8'))

             for inter in self.browse(cr, uid, ids, context=context):
             id = inter.id
             res[id] = ''
             if inter:
             first_date = None
             last_date = None
             allPlanned = True
             for task in inter.tasks :
             first_date = max(first_date, task.date_start)

             last_date = max(last_date, task.date_end)

             if task.state == 'draft' :
             allPlanned = False

             if last_date:
             last_date = fields.datetime.context_timestamp(cr, uid,
             datetime.strptime(last_date, '%Y-%m-%d  %H:%M:%S')
             , context)

             if first_date:
             first_date = fields.datetime.context_timestamp(cr, uid,
             datetime.strptime(first_date, '%Y-%m-%d  %H:%M:%S')
             , context)

             if first_date:
             if inter.progress_rate >= 100 and last_date:
             res[id] = _(' Ended date ') + last_date.strftime(_("%A, %d %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             elif inter.progress_rate == 0:
             res[id] = _(' Scheduled start date ') + first_date.strftime(_("%A, %d %B %Y %H:%M").encode('utf-8')).decode('utf-8')

             elif last_date and allPlanned:
             res[id] = _(' Scheduled end date ') + last_date.strftime(_("%A, %d %B %Y %H:%M").encode('utf-8')).decode('utf-8')
             else:
             res[id] = _(' All tasks not planned ')

             if inter.state == 'cancelled':
             if inter.cancel_reason:
             res[id] += inter.cancel_reason
             else:
             res[id] = _(' intervention cancelled ')

             locale.setlocale(locale.LC_ALL, loc)
             return res
             */
        };

        service.preModal = function (data) {
            if (data.action.id === 'add') {
                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                    data.model.create_task = company.add_intervention_window_create_task;
                    data.model.sync_state_from_tasks = company.intervention_window_synchronize_status;
                });
            }
            if (data.action.id === 'copy') {
                return service.createCollectionTasks(data.model, 10)
                    .then(function (collection) {
                        // warning !
                        // we don't have paging so if we have too many tasks, all of them won't be display !!
                        // maybe we should use a filter search, a array instead of collection...
                        data.model.tasksToDuplicate = angular.copy(collection);
                        _.forEach(data.model.tasksToDuplicate.items, function(task) {
                            delete task.project_id;
                            delete task.date_start;
                            delete task.state;
                        });
                        return data;
                    });
            }
            if (data.action.id === 'edit') {
                let request;
                if(data.model.ask_id) {
                    request = swif.data.get('intervention_request', data.model.ask_id[0])
                    .then(function (request) {
                        data.model.note_for_requester_copy = request.note_for_requester;
                        return data
                    });
                }

                let tasks = service.createCollectionTasks(data.model, 8)
                    .then(function (collection) {
                        data.model.fullTasks = collection;
                        return data;
                    });

                return $q.all([
                    request,
                    tasks
                ]).then(() => data);
            }
        };

        service.preModalTask = function (data) {
            taskService._preModal(data);
            if(data.action.id === 'attachments') {
                swif.attachment.attachmentPreModal(
                    data,
                    swif.collections.getCollection('interventions-tasks')
                );
            }
        };

        service.preValidate = function (data) {
            var validated = swif.collections.preValidate(data);
            var params;
            if (data.action.id === 'finish') {
                data.model.state = 'finished';
            } else if (data.action.id === 'cancel') {
                data.model.state = 'cancelled';
            } else if (data.action.id === 'reopen') {
                params = {
                    args: [data.model.id]
                };
                swif.data.updateObj(params, data.model);
            } else if (data.action.id === 'close') {
                params = {
                    args: [data.model.id]
                };
                swif.data.updateObj(params, data.model);
            } else if (data.action.id === 'add') {
                //handle create_task
                if (data.model.create_task && data.model._tasks.length) {
                    var tasks = angular.copy(data.model._tasks);
                    var deferred = [];
                    delete data.model._tasks;
                    data.model.tasks = [];
                    angular.forEach(tasks, function(task) {
                        // send a flag to task model to know whether the feature is activated or not
                        var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
                        if (siteOnTaskFeature) {
                            task.has_site_on_task_feature = siteOnTaskFeature;
                        }
                        var ctask = angular.copy(task);
                        var tasksToPush = []
                        if (Array.isArray(ctask.user_id) && Number.isInteger(ctask.user_id[1])) {
                            // Duplicate task with main attribute when multiple user_ids
                            var user_ids = ctask.user_id;
                            ctask.user_id = [user_ids.shift(), ''];
                            tasksToPush.push(ctask);
                            for (const id of user_ids) {
                                var dupTask = angular.copy(ctask);
                                dupTask.user_id =  [id, ''];
                                // Remove useless attributes for secondary tasks
                                delete dupTask.consumable_request_ids
                                delete dupTask.consumable_asks
                                delete dupTask.consumables
                                delete dupTask.vehicule
                                delete dupTask.equipment_ids
                                delete dupTask.purchase_order
                                delete dupTask.oil_price
                                delete dupTask.oil_qtity
                                delete dupTask.km
                                tasksToPush.push(dupTask);
                            }
                        } else {
                            tasksToPush.push(ctask);
                        }
                        for (const t of tasksToPush) {
                            deferred.push(swif.data.sanitizeData('task', t).then(function(stask) {
                                data.model.tasks.push([0, 0, stask]);
                                return true;
                            }));
                        }
                    })
                    return $q.all(deferred).then(function() {
                        return true;
                    });
                }
            } else if (data.action.id === 'copy') {
                //Duplicate intervention (and associated tasks)
                //we have already delete with swif.collections.preValidate(data) : id , state and actions
                if (data.model.tasks.length>0) {
                    var promises = [];
                    data.model.tasks = [];
                    _.forEach(data.model.tasksToDuplicate.items, function(task) {
                        var ctask = angular.copy(task);
                        promises.push(swif.data.sanitizeData('task', ctask).then(function (stask) {
                            //we have already delete with service.preModal : project_id , state and date_start
                            data.model.tasks.push([0, 0, stask]);
                            return true;
                        }));
                    });
                    return $q.all(promises).then(function () {
                        return true;
                    });
                }
            } else if (data.action.id === 'details') {
                // Get all attachments
                AttachmentService.addAttachments(data.model)
                // Open details modal
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/openstc/intervention_details_modal.html',
                    controller: 'InterventionDetailsModalController',
                    size: 'lg',
                    resolve: {
                        modalParams: function () {
                            return data;
                        }
                    }
                });
            } else if (data.action.id === 'transfer') {
                var transferred_inter = {
                    service_id: data.model.service_id ? data.model.service_id[0]: false,
                    note: data.model.note || '',
                    user_ids: data.model.user_ids || [],
                    address_ids: data.model.address_ids || [],
                    add_claimer: data.model.add_claimer || false,
                    add_followers: data.model.add_followers || false,
                    save_as_template: data.model.save_as_template || ''
                };
                return swif.data.callKw(
                    'intervention',
                    'transfer_inter',
                    [data.model.id],
                    transferred_inter
                );
            }
            return validated;
        };

        service.callbackMessage = function (error, data) {
            swif.collections.defaultCallbackMessage(error, data);
            if (error) {
                return;
            }
            switch (data.action.id) {
                case 'schedule':
                    swif.message.addInfo('Intervention scheduled successfully');
                    break;
                case 'unschedule':
                    swif.message.addInfo('Intervention unscheduled successfully');
                    break;
                case 'transfer':
                    swif.message.addInfo('L\'intervention a été transférée avec succès');
                    break;
                case 'cancel':
                    swif.message.addInfo('Intervention cancelled successfully');
                    break;
                case 'finish':
                    swif.message.addInfo('Intervention finished successfully');
                    break;
                case 'close':
                    if (data.result.length === 0) {
                        swif.message.addInfo('Intervention can\'t be closed');
                    } else {
                        swif.message.addInfo('Intervention closed successfully');
                    }
                    break;
            }
        };

        service.refreshAllCollections = function () {
            swif.collections.refreshCollections(['interventions'])
                .then(function () {
                    swif.collections.getCollection('interventions').refreshCurrent()
                        .then(function (intervention) {
                            service.createCollectionTasks(intervention);
                        });
                });
        };

        service.collectionCallback = function (collection, data) {
            //refresh one
            if (data.action.id === 'add') {
                data.model.state = 'open';
                delete data.model.create_task;
            }
            if (data.action.id === 'schedule') {
                data.model.state = 'scheduled';
                collection.updateItem(data.model);
            } else if (data.action.id === 'unschedule') {
                data.model.state = 'open';
                collection.updateItem(data.model);
            } else if (data.action.id === 'close') {
                data.model.state = 'done';
                collection.updateItem(data.model);
            } else if (data.action.id === 'pending') {
                data.model.state = 'pending';
                collection.updateItem(data.model);
            } else if (data.action.id === 'transfer') {
                collection.updateItem(data.model);
            }
            collection.fasterCallback(data);
        };

        service.callback = function (error, data) {
            service.callbackMessage(error, data);
            if (error) {return;}
            var interventions = swif.collections.getCollection('interventions');
            service.collectionCallback(interventions, data);
        };

        service.callbackTask = function (error, data) {
            if (error) {
                return;
            }
            var tasks = swif.collections.getCollection('interventions-tasks');
            var interventions = swif.collections.getCollection('interventions');
            if ((data.action.id === 'add' || data.action.id === 'edit') && data.model.recurrence){
                tasks.getItems();
            } else if (data.action.id === 'details') {
                // Get all attachments
                AttachmentService.addAttachments(data.model)
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/openstc/task_details_modal.html',
                    controller: 'TaskDetailsModalController',
                    size: 'lg',
                    resolve: {
                        modalParams: function () {
                            return data;
                        }
                    }
                });
            } else {
                taskService.callbackMessage(error, data);
                taskService.collectionCallback(tasks, data);
                if (data.action.id === 'add') {
                    AchatsService.product.emptyConsumablesCart();
                }
                if (_.contains(['add', 'edit', 'done', 'notfinished'], data.action.id)) {
                    if (data.model.project_id) {
                        _.forEach(interventions.items, function (inter) {
                            if (inter.id === data.model.project_id[0]) {
                                interventions.updateItem(inter);
                            }
                        });
                    }
                }
            }
        };

        service.getWorks = function (intervention) {
            var filter = {};
            swif.data.addFilter(filter, 'task_id.project_id.id', '=', intervention.id);
            return swif.data.get('work', undefined, filter);
        };

        service.getRequester = function (intervention) {
            if (intervention) {
                if (intervention.ask_id) {
                    var params = {fields: ['partner_address', 'people_email', 'people_phone', 'people_name']};
                    return swif.data.get('intervention_request', intervention.ask_id[0], params)
                        .then(function (request) {
                            if (request.partner_address) {
                                return swif.data.get('partner_address', request.partner_address[0])
                                    .then(function (partner_address) {
                                        return partner_address;
                                    });
                            } else {
                                return {
                                    name: request.people_name,
                                    email: request.people_email,
                                    phone: request.people_phone,
                                    _type:'partner_address'
                                };
                            }
                        });
                }
            }
            return $q.when();
        };

        service.getDepartmentManager = function (intervention) {
            if (intervention) {
                if (intervention.service_id) {
                    var params = {fields: ['manager_id']};
                    return swif.data.get('department', intervention.service_id[0], params)
                        .then(function (department) {
                            if (department.manager_id) {
                                return swif.data.get('user', department.manager_id[0])
                                    .then(function (user) {
                                        return user;
                                    });
                            }
                        });
                }
            }
            return $q.when();
        };

        service.updateFilters = function (filters, intervention) {
            filters.department = {fields:['id', 'name', 'complete_name']};
            filters.vehicule = {fields:['id', 'name', 'complete_name', 'km']};
            filters.equipments = {fields:['id', 'name', 'complete_name']};
            filters.tasksRanges = {};
            filters.interTemplates = {fields: ['name', 'category_id', 'description']};
            swif.data.addFilter(
                filters.department,
                'technical', '=', true
            );
            swif.data.addFilter(
                filters.department,
                'is_assignable_to_project', '=', true
            );
            if (intervention.equipment_id) {
                swif.data.get('equipment', intervention.equipment_id[0], {fields: ['maintenance_service_ids']})
                    .then(function (eq) {
                        if (_.size(eq.maintenance_service_ids) > 0) {
                            swif.data.addFilter(
                                filters.department,
                                'id', 'in',
                                eq.maintenance_service_ids
                            );
                        }
                    });
            }
            swif.data.addFilter(filters.tasksRanges, '|');
            swif.data.addFilter(filters.tasksRanges, 'service_ids', '=', false);
            swif.data.addFilter(filters.tasksRanges, 'service_ids', 'in', swif.user.getAuthenticatedUserData().service_ids);
        };

        return service;
    }

})();
